import { Ticket } from '@work4all/models/lib/Classes/Ticket.entity';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';

export const TicketPreviewFields: Ticket<EMode.query> = {
  id: null,
  title: null,
  creationDate: null,
  number: null,
  followUpDate: null,
  problemDescription: null,
  status1: null,
  editor1: {
    id: null,
    displayName: null,
    lastName: null,
    firstName: null,
    userKind: null,
  },
  editor2: {
    id: null,
    displayName: null,
    lastName: null,
    firstName: null,
    userKind: null,
  },
  attachmentList: [
    {
      id: null,
      fileName: null,
      displayName: null,
      fileInfos: {
        fileSize: null,
        downloadUrl: null,
        fileEntityFilename: null,
        previewUrl: null,
        previewMimeType: null,
        downloadMimeType: null,
        fileRequestType: null,
        fileServiceProviderInfos: {
          customUrl: null,
          exists: null,
          fileName: null,
          fspUrl: null,
          id: null,
          key: null,
          mimeType: null,
          size: null,
          thumbnail: null,
        },
      },
      lastModificationDate: null,
    },
  ],
  projectId: null,
  projectProcessId: null,
  projectProcess: {
    id: null,
    process: null,
  },
  businessPartnerId: null,
  businessPartnerType: null,
  businessPartner: {
    id: null,
    businessPartnerType: null,
    data: {
      customer: {
        id: null,
        name: null,
        website: null,
        isPrivateCustomer: null,
        postIt: {
          id: null,
          date: null,
          formName: null,
          body: null,
          user: {
            id: null,
            displayName: null,
          },
        },
        street: null,
        postalCode: null,
        city: null,
      },
      supplier: {
        id: null,
        name: null,
        website: null,
        isPrivateCustomer: null,
        postIt: {
          id: null,
          date: null,
          formName: null,
          body: null,
          user: {
            id: null,
            displayName: null,
          },
        },
        street: null,
        postalCode: null,
        city: null,
      },
    },
  },
  contract: {
    id: null,
    number: null,
    contractNumber: null,
    contractDate: null,
    note: null,
    isClosed: null,
    positionList: [
      {
        id: null,
        index: null,
        number: null,
        shortText: null,
        longtext: null,
        positionKind: null,
        amount: null,
        unit: null,
        finishedDate: null,
        finishedByUserId: null,
        finishedNote: null,
        article: {
          id: null,
          name: null,
          notdeductable: null,
          isActivity: null,
        },
        isFinished: null,
      },
    ],
  },
  contactId: null,
  contact: {
    id: null,
    displayName: null,
    businessPartnerId: null,
    businessPartnerType: null,
    eMail: null,
    name: null,
    firstName: null,
    role: null,
    salutation: {
      id: null,
      isFemale: null,
      isMale: null,
    },
    businessPartner: {
      id: null,
      data: {
        customer: {
          id: null,
          name: null,
        },
        supplier: {
          id: null,
          name: null,
        },
      },
    },
  },
  project: {
    id: null,
    name: null,
    number: null,
  },
  ticketKind: {
    id: null,
    name: null,
  },
  solutionText: null,
  position: {
    id: null,
    number: null,
    shortText: null,
    longtext: null,
    amount: null,
    unit: null,
    isFinished: null,
  },
};
